import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

class TillList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "TillList"}
                {...props}
                columns={{
                    [componentConfig.idfield]: {header: 'Kód', width: 1, sortable, filterable},
                    "displayname": {header: 'Név', width: 6, sortable, filterable},
                    "pos.name": {header: 'Eladási hely (POS)', width: 5, sortable, filterable},
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default TillList;
